import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FnCheckboxFilterComponent } from './fn-checkbox-filter.component';
import { FnTranslateModule } from './../../i18n/index';
import { FnCoreModule } from '../../core/index';

export * from './fn-checkbox-filter.component';
export * from './fn-checkbox-filter.model';

/**
 * Exports the required FnButtonComponenet to create simple dropDown and grouped dropdown check list.
 * Making them available for import by NgModules that import this module.
 */
@NgModule({
  imports: [CommonModule, FormsModule, FnTranslateModule, FnCoreModule.forRoot()],
  declarations: [FnCheckboxFilterComponent],
  providers: [],
  exports: [FnCheckboxFilterComponent]
})
export class FnCheckboxFilterModule {

}
